import { pluralize } from '@utils/textHelper';
import { emptyList } from '@constants/empty';
import { QUESTION_TYPE_MAP } from '@constants/quiz';

export const getSubjectiveMarksInfo = (questionScore) => {
  const info = {
    color: 'var(--color-i-red)',
    text: "You didn't Attempt"
  };

  if (questionScore === null) {
    return info;
  }

  info.text = `${pluralize(questionScore, 'mark')}`;

  if (questionScore === 0) {
    info.color = 'var(--color-i-red)';
  } else if (questionScore > 0) {
    info.color = 'var(--color-i-green)';
  } else if (questionScore < 0) {
    info.color = 'var(--color-i-red)';
  }

  return info;
};

export const getObjectiveMarksInfo = (
  type,
  isCorrectAttempt,
  hasUserAttempted,
  questionScore,
  positiveScore,
  negativeScore
) => {
  const info = {
    color: 'var(--color-i-red)',
    text: "You didn't Attempt",
    outOf: null
  };

  if (isCorrectAttempt) {
    info.color = 'var(--color-i-green)';

    info.text =
      type === QUESTION_TYPE_MAP.MCQ
        ? `+${pluralize(questionScore, 'mark')}`
        : `+${pluralize(positiveScore, 'mark')}`;

    info.outOf =
      type === QUESTION_TYPE_MAP.MCQ && questionScore < positiveScore
        ? ` of ${pluralize(positiveScore, 'mark')}`
        : null;
  } else if (hasUserAttempted) {
    info.color = 'var(--color-i-red)';
    info.text = `${negativeScore > 0 ? '-' : ''}${pluralize(
      negativeScore,
      'mark'
    )}`;
  }

  return info;
};

export const getCorrectOption = (answersList = emptyList) => {
  for (let i = 0; i < answersList.length; i += 1) {
    if (answersList[i]) {
      return answersList[i];
    }
  }
  return null;
};
